import Raect , {useState} from 'react'
import MoviesPage from './MoviesPage'


export default function PupolarMovies(){
 

    return(
        
        <div>
            <MoviesPage/>
          
        </div>
    )


}